const store = require('store');
function get(key) {
    const stringifiedData = store.get(key, undefined);
    if (!stringifiedData) {
        return undefined;
    }
    return JSON.parse(stringifiedData);
}
function remove(key) {
    store.remove(key);
}
function set(key, newData) {
    const stringifiedData = JSON.stringify(newData);
    store.set(key, stringifiedData);
}
function add(key, value) {
    const savedData = get(key) || {};
    try {
        // Merges two arrays.
        if (Array.isArray(savedData) && Array.isArray(value)) {
            set(key, [...savedData, ...value]);
            return;
        }
        // Doesn't merge if trying to add an Array to a different type or vice versa.
        if (Array.isArray(savedData) || Array.isArray(value)) {
            throw new Error('Cannot add to a different type');
        }
        // If stored value is a string, returns
        if (typeof savedData === 'string' && typeof value === 'string') {
            throw new Error('Cannot add to a string');
        }
        // If stored value is a number, returns
        if (typeof savedData === 'number' && typeof value === 'number') {
            throw new Error('Cannot add to a number');
        }
        if (savedData === null || value === null) {
            throw new Error('Cannot add to `null`');
        }
        // All other cases.
        if (typeof savedData === typeof value) {
            set(key, { ...savedData, ...value });
        }
        else {
            throw new Error('Cannot add to a different type');
        }
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
    }
}
function clearAll() {
    store.clearAll();
}
export const storage = { get, set, remove, clearAll, add };
